// Testi dell'import da marchi: codici di errore del backend/worker e stati.

export const ERRORI = {
	openai_not_configured: 'OpenAI non è attivo: configuralo in Impostazioni > AI.',
	brand_url_missing: "Manca l'URL del sito della marca: impostalo nella marca o nelle impostazioni di import.",
	brand_not_found: 'Marca non trovata.',
	job_already_running: "C'è già un'operazione in corso per questa marca.",
	rules_missing: 'Genera e attiva le regole prima di scansionare.',
	rules_not_found: 'Regole non trovate.',
	rules_not_tested: 'Prova le regole sui campioni prima di attivarle.',
	no_product_urls: 'Nessuna pagina prodotto trovata (né nella sitemap né navigando il sito): configura la navigazione del sito nelle regole oppure controlla sitemap e filtri URL.',
	no_pages: 'Nessuna pagina campione scaricabile.',
	not_a_shop: 'Le pagine trovate non hanno prezzo, SKU o EAN: il sito della marca è una vetrina (oppure i filtri URL non puntano ai prodotti).',
	requires_browser: 'Le pagine non contengono i dati nell’HTML: imposta la modalità Browser e riprova.',
	blocked_forbidden: 'Il sito della marca ha rifiutato le richieste (403). La scansione è stata fermata.',
	blocked_challenge: 'Il sito della marca ha una protezione anti-bot. La scansione è stata fermata.',
	blocked_rate_limit: 'Il sito della marca limita le richieste. La scansione è stata fermata.',
	structure_changed: 'Il sito della marca è cambiato: controlla e conferma le nuove regole.',
	openai_rate_limit: 'Limite di richieste dell’account OpenAI raggiunto: riprova tra qualche minuto.',
	openai_request_too_large: 'Le pagine sono troppo grandi per il limite di token dell’account OpenAI.',
	openai_quota: 'Credito OpenAI esaurito: controlla il piano dell’account.',
	openai_error: 'OpenAI ha risposto con un errore.',
	url_other_site: 'La pagina deve essere del sito della marca.',
	url_not_allowed: 'Indirizzo non ammesso.',
	robots_disallow: 'Il robots.txt del sito vieta questa pagina.',
	page_not_found: 'Pagina non trovata.',
	aws_not_configured: 'Configura AWS S3 per caricare le immagini.',
	nothing_to_approve: 'Nessun prodotto approvabile nella selezione.',
	not_editable: 'Il prodotto è già importato o in importazione.',
	enqueue_failed: 'Impossibile mettere in coda l’operazione, riprova.',
	worker_lost: 'Il processo si è interrotto: riprova.',
	internal_error: 'Errore interno.',
	duplicate: 'Già presente in catalogo (stesso EAN/SKU).',
};

export const testoErrore = err => {
	if (!err) return '';
	if (typeof err === 'string') return ERRORI[err] || err;
	if (Array.isArray(err.error) && err.error.length) {
		return err.error.map(e => (typeof e === 'string' ? e : e.msg)).join(' · ');
	}
	return ERRORI[err.message] || err.message || 'Errore';
};

export const TIPI_JOB = {
	generate_rules: 'Generazione regole',
	preview_rules: 'Prova regole',
	scan: 'Scansione',
	rewrite: 'Riscrittura testi',
	translate: 'Traduzione testi',
	snapshot: 'Copia pagina per la taratura',
	approve: 'Importazione',
};

export const STATI_JOB = {
	queued: { testo: 'In coda', colore: 'grey' },
	running: { testo: 'In corso', colore: 'primary' },
	done: { testo: 'Completato', colore: 'success' },
	failed: { testo: 'Non riuscito', colore: 'error' },
	blocked: { testo: 'Bloccato dal sito', colore: 'error' },
	needs_review: { testo: 'Da rivedere', colore: 'warning' },
	cancelled: { testo: 'Annullato', colore: 'grey' },
};

export const STATI_PRODOTTO = [
	{ value: 'new,updated', testo: 'Da valutare' },
	{ value: 'approved,importing', testo: 'In importazione' },
	{ value: 'imported', testo: 'Importati' },
	{ value: 'rejected', testo: 'Scartati' },
	{ value: 'error', testo: 'In errore' },
];

// stati delle versioni delle regole: [testo, colore]
export const STATI_REGOLE = { active: ['Attive', 'success'], draft: ['Bozza', 'warning'], broken: ['Superate dal sito', 'error'], archived: ['Archiviate', 'grey'] };

// come il worker ha trovato gli URL prodotto (discovery / crawlPreview.source)
export const FONTI_URL = { sitemap: 'Sitemap', crawl_rules: 'Navigazione con regole', crawl_auto: 'Navigazione automatica' };

export const CAMPI = { name: 'Nome', images: 'Immagini', price: 'Prezzo', codice: 'SKU/EAN' };

export const attivo = job => job && (job.status === 'queued' || job.status === 'running');
